<script setup>
import { defineProps, defineEmits} from "vue";
import LinhaDeAditivoResumo from "./LinhaDeAditivoResumo.vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
    "aditivo",
]);

const emits = defineEmits([
    "update:alteraAditivo",
]);

//==================================================================//
//========================= Altera Aditivo =========================//
//==================================================================//

const alteraAditivo = (update) =>{

    update.id = props?.aditivo?.id;
    emits('update:alteraAditivo',update);

};

</script>

<template>

    <div
        class="c-table__row-group"
    >

        <LinhaDeAditivoResumo
            :dado="props?.dado"
            :aditivo="props?.aditivo"
            @update:alteraAditivo="alteraAditivo"
        ></LinhaDeAditivoResumo>

    </div>

</template>

<style scoped>

.c-table__row-group{
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / -1;
}

</style>
